module.exports = __webpack_public_path__ + "img/Bermuda.be3ae9aa.svg";